import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '../../common/react/CommonStyles';
import { cssClass, Style } from '../../style';

const CSS_PREFIX = 'LearnTableau';
export namespace LearnTableauStyles {

  export const link = cssClass(CSS_PREFIX, 'link', {
    fontWeight: 'bold',
    color: CommonStyles.Colors.HyperlinkBlue,
    fontSize: 14,
  });

  export const text = cssClass(CSS_PREFIX, 'Text', {
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '21px',
    color: CommonStyles.Colors.Grey51,
    paddingLeft: '12px'
  });

  export const banner = cssClass(CSS_PREFIX, 'Banner', {
    backgroundColor: CommonStyles.Colors.Grey250,
    height: 44,
    verticalAlign: 'middle',
    display: 'flex',
    width: '100%'
  });

  export const arrow = cssClass(CSS_PREFIX, 'Arrow', {
    fill: CommonStyles.Colors.HyperlinkBlue,
    height: '1.2em',
    width: '1.2em',
    display: 'inline-block',
    position: 'relative',
    top: '4px'
  });
}
